/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParamsDto } from './paramsDto';


export interface EtapeEncoursDto { 
    /**
     * Service name
     */
    nomService: string;
    /**
     * Task description
     */
    descriptionTache: string;
    /**
     * Action performed
     */
    actionEffectue: string;
    /**
     * delay
     */
    delai?: string | null;
    /**
     * reception date
     */
    dateDebut?: string | null;
    /**
     * completion date
     */
    dateFin?: string | null;
    /**
     * list of params
     */
    params: Array<ParamsDto>;
}

